
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dat-lich-kham",
      function () {
        return require("private-next-pages/dat-lich-kham/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dat-lich-kham"])
      });
    }
  